import { atom } from "jotai";

export const layoutAtom = atom("layout1");
